<template>
  <section>

  </section>
</template>

<script>
export default {
  name: 'link-report'
}
</script>

<style scoped>

</style>
